module.exports = __webpack_public_path__ + "media/images/countrysquared/tl-bf59792bbace59fbc10d31b02f89ab83.svg";